/**
 * Design-Studio name → built route.
 *
 * Koral's tracker names two screens differently from the codebase, and a link
 * using the tracker's name would otherwise dead-end on the 404 catch-all. This
 * table resolves those names to the screen that implements them.
 *
 * These are aliases, not pages. Nothing new is rendered — each redirects to the
 * screen that does the work.
 *
 * The Build V2 transition redirects are GONE (2026-09-03, on Koral's sign-off
 * of the V2 structure). They carried the six routes the reconfigure retired —
 * dentist-treatment-dashboard, clinical-encounter-workspace,
 * patient-profile-lookup, dental-monitoring, the clinician's my-smile-review
 * and patient-treatment-monitoring — so QA's existing bookmarks kept working
 * while the new structure was reviewed. Those routes now 404, which is the
 * intended end state: a retired route that silently still works is a route
 * nobody ever stops using. `docs/build-v2-reconfigure-plan.md` records the
 * before/after mapping if an old link ever needs tracing.
 */
export const DESIGN_STUDIO_ALIASES = [
  {
    alias: 'clinical-operations/chair-side-visit',
    target: '/clinical-operations/chair-side-workspace',
    note: 'Chair-side visit is the Chair-side Workspace — where the chair-side encounter is recorded.',
  },
];

export default DESIGN_STUDIO_ALIASES;
